module.exports = __webpack_public_path__ + "static/media/top5-buenos-aires.961c25b1.md";